var nop = (function() {
    window.setLocation = function (url) {
        window.location.href = url;
    }

    return {
        addAntiForgeryToken: function(data) {
            //if the object is undefined, create a new one.
            if (!data) {
                data = {};
            }
            //add token
            var tokenInput = $('input[name=__RequestVerificationToken]');
            if (tokenInput.length) {
                data.__RequestVerificationToken = tokenInput.val();
            }
            return data;
        }
    };
})();

function displayPopupNotification(msg, type, displayInModal) {
    var $closeAlert = $('<button/>', {
        "class": "close",
        "type": "button",
        "attr": {
            "data-dismiss": "alert"
        },
        "text": '×'
    });
    var $alert = $('<div/>', {
        "class": "alert alert-dismissible fade show error-message-modal",
        "html": msg
    });

    if (type === 'error') $alert.addClass('alert-danger');
    else if (type === 'warning') $alert.addClass('alert-danger');
    else $alert.addClass('alert-success');

    $alert.append($closeAlert).delay(8000).fadeOut(2000, function() {
        $(this).remove();
    })
    .appendTo("#alerts");
}
